"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReplayGain = void 0;
const common = require("../common/Util");
var NameCode;
(function (NameCode) {
    NameCode[NameCode["not_set"] = 0] = "not_set";
    NameCode[NameCode["radio"] = 1] = "radio";
    NameCode[NameCode["audiophile"] = 2] = "audiophile";
})(NameCode || (NameCode = {}));
var ReplayGainOriginator;
(function (ReplayGainOriginator) {
    ReplayGainOriginator[ReplayGainOriginator["unspecified"] = 0] = "unspecified";
    ReplayGainOriginator[ReplayGainOriginator["engineer"] = 1] = "engineer";
    ReplayGainOriginator[ReplayGainOriginator["user"] = 2] = "user";
    ReplayGainOriginator[ReplayGainOriginator["automatic"] = 3] = "automatic";
    ReplayGainOriginator[ReplayGainOriginator["rms_average"] = 4] = "rms_average";
})(ReplayGainOriginator || (ReplayGainOriginator = {}));
exports.ReplayGain = {
    len: 2,
    get: (buf, off) => {
        const gain_type = common.getBitAllignedNumber(buf, off, 0, 3);
        const sign = common.getBitAllignedNumber(buf, off, 6, 1);
        const gain_adj = common.getBitAllignedNumber(buf, off, 7, 9) / 10.0;
        if (gain_type > 0) {
            return {
                type: common.getBitAllignedNumber(buf, off, 0, 3),
                origin: common.getBitAllignedNumber(buf, off, 3, 3),
                adjustment: (sign ? -gain_adj : gain_adj)
            };
        }
        return undefined;
    }
};
